var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentTerminal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.632,
    height: 60,
    viewBox: "0 0 30.632 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-card-reader-475269",
    transform: "translate(544.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245778",
    "data-name": "Path 245778",
    d: "M8.826.239l-4.8,5.013L1.2,2.357a.682.682,0,0,0-.988,0,.683.683,0,0,0,0,.988L3.53,6.735a.682.682,0,0,0,.988,0L9.884,1.228a.682.682,0,0,0,0-.988.706.706,0,0,0-1.059,0Z",
    transform: "translate(-534.555 7.88)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245779",
    "data-name": "Path 245779",
    d: "M0,12.214H19.19V0H0ZM.693.706H18.5v10.8H.693Z",
    transform: "translate(-539.171 5.225)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245780",
    "data-name": "Path 245780",
    d: "M29.163,0H1.535A1.548,1.548,0,0,0,0,1.535V47.372a1.548,1.548,0,0,0,1.535,1.535H3.628v7.744A3.4,3.4,0,0,0,6.977,60H23.791a3.35,3.35,0,0,0,3.349-3.349V48.907h1.954a1.548,1.548,0,0,0,1.535-1.535V1.535A1.447,1.447,0,0,0,29.163,0ZM17.3,59.3H6.977a2.65,2.65,0,0,1-2.651-2.651V48.907h3.7v5.721h1.4V48.907H11.3v5.721h1.4V48.907h4.6Zm4.744,0H18.07v-10.4h3.977Zm4.465-2.651A2.65,2.65,0,0,1,23.86,59.3H22.744v-10.4h3.837v7.744ZM29.3,47.372a.15.15,0,0,1-.139.139H1.535a.15.15,0,0,1-.139-.139V1.535A.15.15,0,0,1,1.535,1.4H29.163a.15.15,0,0,1,.139.139Z",
    transform: "translate(-544.89 0)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245781",
    "data-name": "Path 245781",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-539.252 27.045)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245782",
    "data-name": "Path 245782",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-532.012 27.045)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245783",
    "data-name": "Path 245783",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-524.773 27.045)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245784",
    "data-name": "Path 245784",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-539.252 21.329)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245785",
    "data-name": "Path 245785",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-532.012 21.329)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245786",
    "data-name": "Path 245786",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-524.773 21.329)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245787",
    "data-name": "Path 245787",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-539.252 32.412)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245788",
    "data-name": "Path 245788",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-532.012 32.412)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245789",
    "data-name": "Path 245789",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-524.773 32.412)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245790",
    "data-name": "Path 245790",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-539.252 37.849)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245791",
    "data-name": "Path 245791",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-532.012 37.849)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245792",
    "data-name": "Path 245792",
    d: "M0,4.377H4.942V0H0ZM.706.706h3.53V3.671H.706Z",
    transform: "translate(-524.773 37.918)",
    fill: "#05cb24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTerminal);
export default __webpack_public_path__ + "static/media/paymentTerminal.338921b03e6ea9b649a4312ed297e466.svg";
export { ForwardRef as ReactComponent };